import { render, staticRenderFns } from "./FiatCurrency.vue?vue&type=template&id=48a65c3c&scoped=true"
import script from "./FiatCurrency.vue?vue&type=script&lang=js"
export * from "./FiatCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a65c3c",
  null
  
)

export default component.exports